import Phaser from 'phaser';

import { BlackjackListener } from 'game-logic';
import { TranslocoService } from '@jsverse/transloco';
import { SceneController } from './controllers/scene-controller';
import { GameServices } from './services/game-services';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

export class BlackjackApp {
  public readonly sceneController: SceneController;

  private readonly gameServices: GameServices;

  constructor(
    gameListener: BlackjackListener,
    themeService: ThemeService,
    useLocalDealer: boolean,
  ) {
    this.gameServices = new GameServices(gameListener, themeService, useLocalDealer);
    this.sceneController = new SceneController(this.gameServices);
  }

  public preloadAssets(scene: Phaser.Scene, localAssetPath: string): void {
    this.gameServices.assetCatalogueService.preloadCatalogue(scene, localAssetPath);
  }

  public preloadTranslations(translocoService: TranslocoService): void {
    this.gameServices.gameTranslationService.preloadTranslations(translocoService);
  }
}
